import { useContext, useEffect } from "react";
import styled from "styled-components";
import AngelingImg from "./solicitarvip/img/angeling_l.gif"
import GTBgImg from "./solicitarvip/img/golden_bug.gif"
import IfritImg from "./solicitarvip/img/Ifrit.gif"
import { OpenPopMenu } from "../../../PopMenuWindow/PopMenuWindow";
import { PageContext } from "../../../Context/PageContext";
import VipRequest from "./solicitarvip/VipRequestRules";
import VipIconImg from "./meucadastro/img/goldstar.png"
import ComandosVip from "./solicitarvip/ComandosVip";
import ServicosDisponiveis from "./solicitarvip/ServicosDisponiveis";
import EventosBonus from "./solicitarvip/EventosBonus";
import RoupasEstilos from "./solicitarvip/RoupasEstilos";


function SolicitarVip() {

        
        const { setPopMenuContent } = useContext(PageContext);


    useEffect(() => {setTimeout(() => {  document.getElementById("MasterAcessoContainer").style.opacity = 1;}, 200)},[])


    return(<MasterContainer id="MasterAcessoContainer">

        <MasterFirstColumn>
            <TitleMaster>
                <ColumItemHeaderIcon iconImg={VipIconImg}/>
                <TitleFont>Doações e acesso VIP</TitleFont>
            </TitleMaster>
            
            <PlansColumnContainer>
                <PlanItemContainer onClick={() => { 
                        setPopMenuContent(<VipRequest />);
                        OpenPopMenu()} }>
                            <PlanTitle >Plano 1</PlanTitle>
                            <PlanName color={"#3c77a4"}>Angeling</PlanName>
                            <PlanIcon icon={AngelingImg} width={"110px"} height={"80px"} margin={"90px 0px 100px  0px"}/>
                            <PlanDays>10 Dias</PlanDays>
                            <PlanPrice>R$15</PlanPrice>
                            <PlanBenefits>
                                • Comandos Liberados<br/>
                                • Atendente VIP <br/>
                                • NPC Estilista <br/>
                            </PlanBenefits>
                </PlanItemContainer>

                <PlanItemContainer onClick={() => { 
                        setPopMenuContent(<VipRequest />);
                        OpenPopMenu()} }>
                            <PlanTitle >Plano 2</PlanTitle>
                            <PlanName color={"#af730b"}>GTB</PlanName>
                            <PlanIcon icon={GTBgImg} width={"100px"} height={"80px"} margin={"80px 0px 100px 0"}/>
                            <PlanDays>20 Dias</PlanDays>
                            <PlanPrice>R$25</PlanPrice>
                            <PlanBenefits>
                                • x2 de pontos de Presença<br/>
                                • Comandos Liberados<br/>
                                • Atendente VIP <br/>
                                • NPC Estilista <br/>
                            </PlanBenefits>
                </PlanItemContainer>

                <PlanItemContainer onClick={() => { 
                         setPopMenuContent(<VipRequest />);
                         OpenPopMenu()} }>
                            
                            <PlanTitle >Plano 3</PlanTitle>
                            <PlanName color={"#c51313"}>Ifrit</PlanName>
                            <PlanIcon icon={IfritImg} width={"136px"} height={"180px"} margin={"20px 0 55px 0"}/>
                            <PlanDays>30 Dias</PlanDays>
                            <PlanPrice>R$30</PlanPrice>
                            <PlanBenefits>
                                • x2 pontos de Presença<br/>
                                • @Autotrade<br/>
                                • Comandos Liberados<br/>
                                • Atendente VIP <br/>
                                • NPC Estilista <br/>
                            </PlanBenefits>
                </PlanItemContainer>
                    
            </PlansColumnContainer>
        </MasterFirstColumn>

                <ComandosVip />
                <ServicosDisponiveis />
                <EventosBonus />
                <RoupasEstilos />

                <Span>
                    <b>Lembrando:</b> Nós não cobramos pelo acesso ao jogo. As doações ajudam a manter esse         projeto de pé.
                    <br/>Como forma de agradecimento pela colaboração, nós retribuímos com os períodos de       acesso VIP ao servidor.
                </Span>
    </MasterContainer>
    );
}

export default SolicitarVip;

const MasterContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    //border: solid 2px black;
    width: 100%;
    opacity: 0;
    transition: .7s ease-in-out;

    @media(max-width: 1000px) {
        width: 90vw;
    }

`

const MasterFirstColumn = styled.h1`
    display: flex;
    flex-direction: column;
    align-items: center;
    //border: solid 2px black;

`;

const TitleMaster = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    border-radius: 10px;
    transition: .3s ease-in-out;
    margin: 20px 0;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    color: white;
    font-size: 12pt;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 0 0px;
    }

`

const TitleFont = styled.span`
    font-size: 24pt;
    font-weight: bold;
    margin: 25px 0;

    @media(max-width: 1000px) {
      font-size: 20pt
    }

`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    margin: 0 55px;
    //border: solid;

    @media(max-width: 1000px) {
        width: 35px;
        height: 35px;
        margin: 0 20px;
    }
    
`

const Title = styled.h3`
    text-align: center;
    //border: solid 2px black;
    padding: 0;
    margin: 0px 0;
`;

const Span = styled.span`
    font-size: 18px;
    font-weight: normal;
    //border: solid 2px black;
    padding: 0;
    text-align: center;
    margin: 10px;
`;

const PlansColumnContainer = styled.div`
    display: flex;
    align-items: start;
    //border: solid;
    margin: 0px 0px;
    justify-content: space-between;
    background-color: rgba(0,0,0,.7);
    border-radius: 5px;

    @media(max-width: 1000px) {
        width: 100%;
        padding: 0;
        flex-direction: column;
        align-items: center;
        justify-content: start;
        //border: solid 1px rgba(0,0,0, 1);
    }

`

const PlanItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 250px;
    height: 680px;
    border: 1px solid rgba(0,0,0,1);
    border-radius: 10px;
    margin: 0px 0px;
    transition: .3s ease-in-out;
    padding: 20px 20px;
    background-color: rgba(0, 0, 0,.7);
    color: white;
    scale: .9;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
        box-shadow: 0px 0px 10px 0px black;
        transform: translate(-5px,-5px);
        scale: 1.0;
    }

    @media(max-width: 1000px) {
        scale: .8;
        width: 90vw;
        border: solid 1px rgba(0,0,0, 1);
        padding: 20px 0px;
        margin: 0;
        scale: .9;
    }
`


const PlanTitle = styled.span`
    display: flex;
    //border: solid;
    font-size: 22pt;
    font-weight: bold;
    color:  ${props => props.color};
    font-style: italic;
`
const PlanName = styled.span`
    display: flex;
    //border: solid;
    font-size: 40pt;
    font-weight: bold;
    color:  ${props => props.color};
    font-style: italic;
`

const PlanIcon = styled.div`
    background-image: url(${props => props.icon});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: ${props => props.width};
    height: ${props => props.height};
    margin: ${props => props.margin};


`

const PlanDays = styled.span`
    display: flex;
    //border: solid;
    font-size: 52pt;
    font-weight: bold;
    color:  ${props => props.color};
    font-style: italic;
`

const PlanPrice = styled.span`
    display: flex;
    //border: solid;
    font-size: 40pt;
    font-weight: bold;
    color:  ${props => props.color};
    font-style: italic;
`
const PlanBenefits = styled.span`
    width: 250px;
    display: flex;
    //border: solid;
    text-align: left;
    font-size: 14pt;
    font-weight: normal;
    color:  ${props => props.color};
    margin-top: 20px;
    font-style: italic;
`


